import LoadingOrderItems from './LoadingOrderItems';

export default LoadingOrderItems;
